import { Injectable } from '@angular/core';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { CreatePersonalClientOptions } from '../../../../../../../../common/src/options/create-personal-client.options';

@Injectable()
export class CreatePersonalClientFormFactory {
  constructor(
    private readonly formFactory: FormFactory) {
  }

  create(): AdvancedForm<CreatePersonalClientOptions> {
    return this.formFactory.create(new CreatePersonalClientOptions(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Sauvegarder', ButtonTypeEnum.Submit),
    ]);
  }
}
